import axios, { AxiosHeaders, AxiosRequestHeaders } from 'axios';

declare module 'axios' {
    interface AxiosRequestConfig {
        disableGlobalErrorHandling?: boolean;
    }
}

export const createAxiosInstance = (headers?: AxiosRequestHeaders) => {
    return axios.create({ withCredentials: true, headers });
};

export const createAxiosInstanceWithJWT = () => {
    return createAxiosInstance(
        new AxiosHeaders({
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('fleet-pro-mfe-identity') || '{}').access_token}`,
        })
    );
};
